import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import getNumberOfLayers from "../../../service/getNumberOfLayers"
import { isFlexible, isMetal, isRigid, isMultiLayer, isBuildUp } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"
import getNumberOfMinPattern from "../getNumberOfMinPattern"

const isValidBeatenThickness = (values: EstimateValues, beatenThickness?: string) => {
  const numberOfMinPattern = getNumberOfMinPattern(values)
  const numberOfLayers = getNumberOfLayers(values)

  switch (beatenThickness) {
    case ESTIMATE_CONSTANT.銅箔厚み["18μm(リジッド)"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["35μm(リジッド)"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["70μm(リジッド)"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["105μm"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["140μm"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["175μm"].value:
      return isRigid(values) && !isMultiLayer(values)

    case ESTIMATE_CONSTANT.銅箔厚み["内層35μm外層18μm"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(リジッド)"].value:
      return isRigid(values) && isMultiLayer(values)

    case ESTIMATE_CONSTANT.銅箔厚み.内層18μm外層35μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層35μm外層35μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層18μm外層70μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層35μm外層70μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層18μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層35μm.value:
    case ESTIMATE_CONSTANT.銅箔厚み.内層70μm外層70μm.value:
      return isRigid(values) && isMultiLayer(values) && !isBuildUp(values) && numberOfMinPattern >= 0.1

    case ESTIMATE_CONSTANT.銅箔厚み["9μm"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["12μm"].value:
      return isFlexible(values) && !isMultiLayer(values)

    case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm未満)"].value:
      return isFlexible(values) && numberOfMinPattern < 0.1 && !isMultiLayer(values)
    case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__片面)"].value:
      return isFlexible(values) && numberOfMinPattern >= 0.1 && numberOfLayers === 1
    case ESTIMATE_CONSTANT.銅箔厚み["18μm(フレキシブル__0.1mm以上__2層)"].value:
      return isFlexible(values) && numberOfMinPattern >= 0.1 && numberOfLayers === 2

    case ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__片面)"].value:
      return isFlexible(values) && numberOfLayers === 1
    case ESTIMATE_CONSTANT.銅箔厚み["35μm(フレキシブル__2層)"].value:
      return isFlexible(values) && numberOfLayers === 2

    case ESTIMATE_CONSTANT.銅箔厚み["内層12.5μm外層12.5μm"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["内層18μm外層18μm(フレキシブル)"].value:
      return isFlexible(values) && isMultiLayer(values)

    case ESTIMATE_CONSTANT.銅箔厚み["35μm(メタル)"].value:
    case ESTIMATE_CONSTANT.銅箔厚み["70μm(メタル)"].value:
      return isMetal(values)

    default:
      return false
  }
}

export default isValidBeatenThickness
